/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/jss/generate-component-factory.js to modify the generation of this file.
import React from 'react';
import Loadable from 'react-loadable';
const UnauthoredComponent = Loadable({
    loader: () => import(/* webpackChunkName: "UnauthoredComponent" */ '../../jss-components/sitecore/UnauthoredComponent'),
    loading: () => <div />,
    modules: ['UnauthoredComponent'],
    });
const Breadcrumbs = Loadable({
    loader: () => import(/* webpackChunkName: "Breadcrumbs" */ '../../jss-components/t01-navigation/Breadcrumbs/index.ts'),
    loading: () => <div />,
    modules: ['Breadcrumbs'],
    });
const Footer = Loadable({
    loader: () => import(/* webpackChunkName: "Footer" */ '../../jss-components/t01-navigation/Footer/index.ts'),
    loading: () => <div />,
    modules: ['Footer'],
    });
const Header = Loadable({
    loader: () => import(/* webpackChunkName: "Header" */ '../../jss-components/t01-navigation/Header/index.ts'),
    loading: () => <div />,
    modules: ['Header'],
    });
const Dashboard = Loadable({
    loader: () => import(/* webpackChunkName: "Dashboard" */ '../../jss-components/t02-layout/e01-templates/Dashboard/index.ts'),
    loading: () => <div />,
    modules: ['Dashboard'],
    });
const GeneralOneColumn = Loadable({
    loader: () => import(/* webpackChunkName: "GeneralOneColumn" */ '../../jss-components/t02-layout/e01-templates/GeneralOneColumn/index.ts'),
    loading: () => <div />,
    modules: ['GeneralOneColumn'],
    });
const GeneralTwoColumnLeft = Loadable({
    loader: () => import(/* webpackChunkName: "GeneralTwoColumnLeft" */ '../../jss-components/t02-layout/e01-templates/GeneralTwoColumnLeft/index.ts'),
    loading: () => <div />,
    modules: ['GeneralTwoColumnLeft'],
    });
const GeneralTwoColumnRight = Loadable({
    loader: () => import(/* webpackChunkName: "GeneralTwoColumnRight" */ '../../jss-components/t02-layout/e01-templates/GeneralTwoColumnRight/index.ts'),
    loading: () => <div />,
    modules: ['GeneralTwoColumnRight'],
    });
const UnauthenticatedOneColumn = Loadable({
    loader: () => import(/* webpackChunkName: "UnauthenticatedOneColumn" */ '../../jss-components/t02-layout/e01-templates/UnauthenticatedOneColumn/index.ts'),
    loading: () => <div />,
    modules: ['UnauthenticatedOneColumn'],
    });
const Accordion = Loadable({
    loader: () => import(/* webpackChunkName: "Accordion" */ '../../jss-components/t02-layout/e02-modules/Accordion/index.ts'),
    loading: () => <div />,
    modules: ['Accordion'],
    });
const ContentBlock = Loadable({
    loader: () => import(/* webpackChunkName: "ContentBlock" */ '../../jss-components/t02-layout/e02-modules/ContentBlock/index.ts'),
    loading: () => <div />,
    modules: ['ContentBlock'],
    });
const DownloadsBlock = Loadable({
    loader: () => import(/* webpackChunkName: "DownloadsBlock" */ '../../jss-components/t02-layout/e02-modules/DownloadsBlock/index.ts'),
    loading: () => <div />,
    modules: ['DownloadsBlock'],
    });
const HeroModule = Loadable({
    loader: () => import(/* webpackChunkName: "HeroModule" */ '../../jss-components/t02-layout/e02-modules/HeroModule/index.ts'),
    loading: () => <div />,
    modules: ['HeroModule'],
    });
const IconTile = Loadable({
    loader: () => import(/* webpackChunkName: "IconTile" */ '../../jss-components/t02-layout/e02-modules/IconTile/index.ts'),
    loading: () => <div />,
    modules: ['IconTile'],
    });
const ImageBlock = Loadable({
    loader: () => import(/* webpackChunkName: "ImageBlock" */ '../../jss-components/t02-layout/e02-modules/ImageBlock/index.ts'),
    loading: () => <div />,
    modules: ['ImageBlock'],
    });
const LinksBlock = Loadable({
    loader: () => import(/* webpackChunkName: "LinksBlock" */ '../../jss-components/t02-layout/e02-modules/LinksBlock/index.ts'),
    loading: () => <div />,
    modules: ['LinksBlock'],
    });
const MemberDetailsForm = Loadable({
    loader: () => import(/* webpackChunkName: "MemberDetailsForm" */ '../../jss-components/t02-layout/e02-modules/MemberDetailsForm/index.ts'),
    loading: () => <div />,
    modules: ['MemberDetailsForm'],
    });
const MemberPreferencesLink = Loadable({
    loader: () => import(/* webpackChunkName: "MemberPreferencesLink" */ '../../jss-components/t02-layout/e02-modules/MemberPreferencesLink/index.ts'),
    loading: () => <div />,
    modules: ['MemberPreferencesLink'],
    });
const PageLevelNotification = Loadable({
    loader: () => import(/* webpackChunkName: "PageLevelNotification" */ '../../jss-components/t02-layout/e02-modules/PageLevelNotification/index.ts'),
    loading: () => <div />,
    modules: ['PageLevelNotification'],
    });
const QuickActionsList = Loadable({
    loader: () => import(/* webpackChunkName: "QuickActionsList" */ '../../jss-components/t02-layout/e02-modules/QuickActionsList/index.ts'),
    loading: () => <div />,
    modules: ['QuickActionsList'],
    });
const QuickActionsTile = Loadable({
    loader: () => import(/* webpackChunkName: "QuickActionsTile" */ '../../jss-components/t02-layout/e02-modules/QuickActionsTile/index.ts'),
    loading: () => <div />,
    modules: ['QuickActionsTile'],
    });
const RichText = Loadable({
    loader: () => import(/* webpackChunkName: "RichText" */ '../../jss-components/t02-layout/e02-modules/RichText/index.ts'),
    loading: () => <div />,
    modules: ['RichText'],
    });
const Tabs = Loadable({
    loader: () => import(/* webpackChunkName: "Tabs" */ '../../jss-components/t02-layout/e02-modules/Tabs/index.ts'),
    loading: () => <div />,
    modules: ['Tabs'],
    });
const VideoBlock = Loadable({
    loader: () => import(/* webpackChunkName: "VideoBlock" */ '../../jss-components/t02-layout/e02-modules/VideoBlock/index.ts'),
    loading: () => <div />,
    modules: ['VideoBlock'],
    });
const FiftyFiftySubLayout = Loadable({
    loader: () => import(/* webpackChunkName: "FiftyFiftySubLayout" */ '../../jss-components/t02-layout/e03-subLayouts/generated/FiftyFiftySubLayout/index.ts'),
    loading: () => <div />,
    modules: ['FiftyFiftySubLayout'],
    });
const FullWidthSubLayout = Loadable({
    loader: () => import(/* webpackChunkName: "FullWidthSubLayout" */ '../../jss-components/t02-layout/e03-subLayouts/generated/FullWidthSubLayout/index.ts'),
    loading: () => <div />,
    modules: ['FullWidthSubLayout'],
    });
const OneThirdTwoThirdsSubLayout = Loadable({
    loader: () => import(/* webpackChunkName: "OneThirdTwoThirdsSubLayout" */ '../../jss-components/t02-layout/e03-subLayouts/generated/OneThirdTwoThirdsSubLayout/index.ts'),
    loading: () => <div />,
    modules: ['OneThirdTwoThirdsSubLayout'],
    });
const QuartersSubLayout = Loadable({
    loader: () => import(/* webpackChunkName: "QuartersSubLayout" */ '../../jss-components/t02-layout/e03-subLayouts/generated/QuartersSubLayout/index.ts'),
    loading: () => <div />,
    modules: ['QuartersSubLayout'],
    });
const ThirdsSubLayout = Loadable({
    loader: () => import(/* webpackChunkName: "ThirdsSubLayout" */ '../../jss-components/t02-layout/e03-subLayouts/generated/ThirdsSubLayout/index.ts'),
    loading: () => <div />,
    modules: ['ThirdsSubLayout'],
    });
const TwoThirdsOneThirdSubLayout = Loadable({
    loader: () => import(/* webpackChunkName: "TwoThirdsOneThirdSubLayout" */ '../../jss-components/t02-layout/e03-subLayouts/generated/TwoThirdsOneThirdSubLayout/index.ts'),
    loading: () => <div />,
    modules: ['TwoThirdsOneThirdSubLayout'],
    });
const GreenId = Loadable({
    loader: () => import(/* webpackChunkName: "GreenId" */ '../../jss-components/t04-security/GreenId/index.ts'),
    loading: () => <div />,
    modules: ['GreenId'],
    });
const OneTimePasscode = Loadable({
    loader: () => import(/* webpackChunkName: "OneTimePasscode" */ '../../jss-components/t04-security/OneTimePasscode/index.ts'),
    loading: () => <div />,
    modules: ['OneTimePasscode'],
    });
const DbAccountSnapshot = Loadable({
    loader: () => import(/* webpackChunkName: "DbAccountSnapshot" */ '../../jss-components/t06-dashboard/DbAccountSnapshot/index.ts'),
    loading: () => <div />,
    modules: ['DbAccountSnapshot'],
    });
const DbAnnualStatements = Loadable({
    loader: () => import(/* webpackChunkName: "DbAnnualStatements" */ '../../jss-components/t06-dashboard/DbAnnualStatements/index.ts'),
    loading: () => <div />,
    modules: ['DbAnnualStatements'],
    });
const DbBPAY = Loadable({
    loader: () => import(/* webpackChunkName: "DbBPAY" */ '../../jss-components/t06-dashboard/DbBPAY/index.ts'),
    loading: () => <div />,
    modules: ['DbBPAY'],
    });
const DbBeneficiaries = Loadable({
    loader: () => import(/* webpackChunkName: "DbBeneficiaries" */ '../../jss-components/t06-dashboard/DbBeneficiaries/index.ts'),
    loading: () => <div />,
    modules: ['DbBeneficiaries'],
    });
const DbFinancialAdviserModule = Loadable({
    loader: () => import(/* webpackChunkName: "DbFinancialAdviserModule" */ '../../jss-components/t06-dashboard/DbFinancialAdviserModule/index.ts'),
    loading: () => <div />,
    modules: ['DbFinancialAdviserModule'],
    });
const DbHeroBanner = Loadable({
    loader: () => import(/* webpackChunkName: "DbHeroBanner" */ '../../jss-components/t06-dashboard/DbHeroBanner/index.ts'),
    loading: () => <div />,
    modules: ['DbHeroBanner'],
    });
const DbImportantNotice = Loadable({
    loader: () => import(/* webpackChunkName: "DbImportantNotice" */ '../../jss-components/t06-dashboard/DbImportantNotice/index.ts'),
    loading: () => <div />,
    modules: ['DbImportantNotice'],
    });
const DbInsuranceCover = Loadable({
    loader: () => import(/* webpackChunkName: "DbInsuranceCover" */ '../../jss-components/t06-dashboard/DbInsuranceCover/index.ts'),
    loading: () => <div />,
    modules: ['DbInsuranceCover'],
    });
const DbInvestments = Loadable({
    loader: () => import(/* webpackChunkName: "DbInvestments" */ '../../jss-components/t06-dashboard/DbInvestments/index.ts'),
    loading: () => <div />,
    modules: ['DbInvestments'],
    });
const DbLatestContributionModule = Loadable({
    loader: () => import(/* webpackChunkName: "DbLatestContributionModule" */ '../../jss-components/t06-dashboard/DbLatestContributionModule/index.ts'),
    loading: () => <div />,
    modules: ['DbLatestContributionModule'],
    });
const DbNextBestActionsModule = Loadable({
    loader: () => import(/* webpackChunkName: "DbNextBestActionsModule" */ '../../jss-components/t06-dashboard/DbNextBestActionsModule/index.ts'),
    loading: () => <div />,
    modules: ['DbNextBestActionsModule'],
    });
const DbNoiInformationBanner = Loadable({
    loader: () => import(/* webpackChunkName: "DbNoiInformationBanner" */ '../../jss-components/t06-dashboard/DbNoiInformationBanner/index.ts'),
    loading: () => <div />,
    modules: ['DbNoiInformationBanner'],
    });
const DbPaymentInformation = Loadable({
    loader: () => import(/* webpackChunkName: "DbPaymentInformation" */ '../../jss-components/t06-dashboard/DbPaymentInformation/index.ts'),
    loading: () => <div />,
    modules: ['DbPaymentInformation'],
    });
const DbProfileSetupActions = Loadable({
    loader: () => import(/* webpackChunkName: "DbProfileSetupActions" */ '../../jss-components/t06-dashboard/DbProfileSetupActions/index.ts'),
    loading: () => <div />,
    modules: ['DbProfileSetupActions'],
    });
const DbSectionHeading = Loadable({
    loader: () => import(/* webpackChunkName: "DbSectionHeading" */ '../../jss-components/t06-dashboard/DbSectionHeading/index.ts'),
    loading: () => <div />,
    modules: ['DbSectionHeading'],
    });
const DbSkeletonLoader = Loadable({
    loader: () => import(/* webpackChunkName: "DbSkeletonLoader" */ '../../jss-components/t06-dashboard/DbSkeletonLoader/index.ts'),
    loading: () => <div />,
    modules: ['DbSkeletonLoader'],
    });
const DbVideoBlock = Loadable({
    loader: () => import(/* webpackChunkName: "DbVideoBlock" */ '../../jss-components/t06-dashboard/DbVideoBlock/index.ts'),
    loading: () => <div />,
    modules: ['DbVideoBlock'],
    });
const Widget = Loadable({
    loader: () => import(/* webpackChunkName: "Widget" */ '../../jss-components/t06-dashboard/subcomponents/Widget/index.ts'),
    loading: () => <div />,
    modules: ['Widget'],
    });
const AccountLockedScreen = Loadable({
    loader: () => import(/* webpackChunkName: "AccountLockedScreen" */ '../../jss-components/t07-account-access/AccountLockedScreen/index.ts'),
    loading: () => <div />,
    modules: ['AccountLockedScreen'],
    });
const ContentNotAvailable = Loadable({
    loader: () => import(/* webpackChunkName: "ContentNotAvailable" */ '../../jss-components/t07-account-access/ContentNotAvailable/index.ts'),
    loading: () => <div />,
    modules: ['ContentNotAvailable'],
    });
const DeviceCheck = Loadable({
    loader: () => import(/* webpackChunkName: "DeviceCheck" */ '../../jss-components/t07-account-access/DeviceCheck/index.ts'),
    loading: () => <div />,
    modules: ['DeviceCheck'],
    });
const DisplayLogoutSuccess = Loadable({
    loader: () => import(/* webpackChunkName: "DisplayLogoutSuccess" */ '../../jss-components/t07-account-access/DisplayLogoutSuccess/index.ts'),
    loading: () => <div />,
    modules: ['DisplayLogoutSuccess'],
    });
const EditUsernameAndPassword = Loadable({
    loader: () => import(/* webpackChunkName: "EditUsernameAndPassword" */ '../../jss-components/t07-account-access/EditUsernameAndPassword/index.ts'),
    loading: () => <div />,
    modules: ['EditUsernameAndPassword'],
    });
const Login = Loadable({
    loader: () => import(/* webpackChunkName: "Login" */ '../../jss-components/t07-account-access/Login/index.ts'),
    loading: () => <div />,
    modules: ['Login'],
    });
const MPRegistrationForm = Loadable({
    loader: () => import(/* webpackChunkName: "MPRegistrationForm" */ '../../jss-components/t07-account-access/MPRegistrationForm/index.ts'),
    loading: () => <div />,
    modules: ['MPRegistrationForm'],
    });
const OnboardingJourney = Loadable({
    loader: () => import(/* webpackChunkName: "OnboardingJourney" */ '../../jss-components/t07-account-access/OnboardingJourney/index.ts'),
    loading: () => <div />,
    modules: ['OnboardingJourney'],
    });
const RecoverUsername = Loadable({
    loader: () => import(/* webpackChunkName: "RecoverUsername" */ '../../jss-components/t07-account-access/RecoverUsername/index.ts'),
    loading: () => <div />,
    modules: ['RecoverUsername'],
    });
const ResetPassword = Loadable({
    loader: () => import(/* webpackChunkName: "ResetPassword" */ '../../jss-components/t07-account-access/ResetPassword/index.ts'),
    loading: () => <div />,
    modules: ['ResetPassword'],
    });
const ResilienceMaintenance = Loadable({
    loader: () => import(/* webpackChunkName: "ResilienceMaintenance" */ '../../jss-components/t07-account-access/ResilienceMaintenance/index.ts'),
    loading: () => <div />,
    modules: ['ResilienceMaintenance'],
    });
const WelcomeBanner = Loadable({
    loader: () => import(/* webpackChunkName: "WelcomeBanner" */ '../../jss-components/t07-account-access/WelcomeBanner/index.ts'),
    loading: () => <div />,
    modules: ['WelcomeBanner'],
    });
const WelcomeDashboardModule = Loadable({
    loader: () => import(/* webpackChunkName: "WelcomeDashboardModule" */ '../../jss-components/t07-account-access/WelcomeDashboardModule/index.ts'),
    loading: () => <div />,
    modules: ['WelcomeDashboardModule'],
    });
const PendingProfileAccountDetailsModule = Loadable({
    loader: () => import(/* webpackChunkName: "PendingProfileAccountDetailsModule" */ '../../jss-components/t08-activate-account/PendingProfileAccountDetailsModule/index.ts'),
    loading: () => <div />,
    modules: ['PendingProfileAccountDetailsModule'],
    });
const PendingProfileActionsModule = Loadable({
    loader: () => import(/* webpackChunkName: "PendingProfileActionsModule" */ '../../jss-components/t08-activate-account/PendingProfileActionsModule/index.ts'),
    loading: () => <div />,
    modules: ['PendingProfileActionsModule'],
    });
const AccountSwitcher = Loadable({
    loader: () => import(/* webpackChunkName: "AccountSwitcher" */ '../../jss-components/t09-multiple-accounts/AccountSwitcher/index.ts'),
    loading: () => <div />,
    modules: ['AccountSwitcher'],
    });
const MemberContactDetails = Loadable({
    loader: () => import(/* webpackChunkName: "MemberContactDetails" */ '../../jss-components/t10-member-details/MemberContactDetails/index.ts'),
    loading: () => <div />,
    modules: ['MemberContactDetails'],
    });
const RestrictionNotification = Loadable({
    loader: () => import(/* webpackChunkName: "RestrictionNotification" */ '../../jss-components/t10-member-details/RestrictionNotification/index.ts'),
    loading: () => <div />,
    modules: ['RestrictionNotification'],
    });
const AnnualStatements = Loadable({
    loader: () => import(/* webpackChunkName: "AnnualStatements" */ '../../jss-components/t11-member-documentation/AnnualStatements/index.ts'),
    loading: () => <div />,
    modules: ['AnnualStatements'],
    });
const SavedApplications = Loadable({
    loader: () => import(/* webpackChunkName: "SavedApplications" */ '../../jss-components/t11-member-documentation/MyApplications/SavedApplications/index.ts'),
    loading: () => <div />,
    modules: ['SavedApplications'],
    });
const SubmittedApplications = Loadable({
    loader: () => import(/* webpackChunkName: "SubmittedApplications" */ '../../jss-components/t11-member-documentation/MyApplications/SubmittedApplications/index.ts'),
    loading: () => <div />,
    modules: ['SubmittedApplications'],
    });
const SubmittedBankAccount = Loadable({
    loader: () => import(/* webpackChunkName: "SubmittedBankAccount" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedBankAccount/index.ts'),
    loading: () => <div />,
    modules: ['SubmittedBankAccount'],
    });
const SubmittedDirectDebit = Loadable({
    loader: () => import(/* webpackChunkName: "SubmittedDirectDebit" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedDirectDebit/index.ts'),
    loading: () => <div />,
    modules: ['SubmittedDirectDebit'],
    });
const SubmittedFinancialHardship = Loadable({
    loader: () => import(/* webpackChunkName: "SubmittedFinancialHardship" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedFinancialHardship/index.ts'),
    loading: () => <div />,
    modules: ['SubmittedFinancialHardship'],
    });
const SubmittedNoticeOfIntent = Loadable({
    loader: () => import(/* webpackChunkName: "SubmittedNoticeOfIntent" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedNoticeOfIntent/index.ts'),
    loading: () => <div />,
    modules: ['SubmittedNoticeOfIntent'],
    });
const SubmittedReachedPreservationAge = Loadable({
    loader: () => import(/* webpackChunkName: "SubmittedReachedPreservationAge" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedReachedPreservationAge/index.ts'),
    loading: () => <div />,
    modules: ['SubmittedReachedPreservationAge'],
    });
const SubmittedSpouseContribution = Loadable({
    loader: () => import(/* webpackChunkName: "SubmittedSpouseContribution" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedSpouseContribution/index.ts'),
    loading: () => <div />,
    modules: ['SubmittedSpouseContribution'],
    });
const SubmittedTransferToAnotherFund = Loadable({
    loader: () => import(/* webpackChunkName: "SubmittedTransferToAnotherFund" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedTransferToAnotherFund/index.ts'),
    loading: () => <div />,
    modules: ['SubmittedTransferToAnotherFund'],
    });
const SubmittedUnrestrictedNonPreserved = Loadable({
    loader: () => import(/* webpackChunkName: "SubmittedUnrestrictedNonPreserved" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedUnrestrictedNonPreserved/index.ts'),
    loading: () => <div />,
    modules: ['SubmittedUnrestrictedNonPreserved'],
    });
const ViewApplicationDetails = Loadable({
    loader: () => import(/* webpackChunkName: "ViewApplicationDetails" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/ViewApplicationDetails/index.ts'),
    loading: () => <div />,
    modules: ['ViewApplicationDetails'],
    });
const AccountsDetailsModule = Loadable({
    loader: () => import(/* webpackChunkName: "AccountsDetailsModule" */ '../../jss-components/t11-member-documentation/e01-notify-employer/AccountsDetailsModule/index.ts'),
    loading: () => <div />,
    modules: ['AccountsDetailsModule'],
    });
const NotifyYourEmployer = Loadable({
    loader: () => import(/* webpackChunkName: "NotifyYourEmployer" */ '../../jss-components/t11-member-documentation/e01-notify-employer/NotifyYourEmployer/index.ts'),
    loading: () => <div />,
    modules: ['NotifyYourEmployer'],
    });
const NotifyYourEmployerConfirmation = Loadable({
    loader: () => import(/* webpackChunkName: "NotifyYourEmployerConfirmation" */ '../../jss-components/t11-member-documentation/e01-notify-employer/NotifyYourEmployerConfirmation/index.ts'),
    loading: () => <div />,
    modules: ['NotifyYourEmployerConfirmation'],
    });
const TransactionsSummary = Loadable({
    loader: () => import(/* webpackChunkName: "TransactionsSummary" */ '../../jss-components/t12-transactions/TransactionsSummary/index.ts'),
    loading: () => <div />,
    modules: ['TransactionsSummary'],
    });
const ViewBalanceHistory = Loadable({
    loader: () => import(/* webpackChunkName: "ViewBalanceHistory" */ '../../jss-components/t12-transactions/ViewBalanceHistory/index.ts'),
    loading: () => <div />,
    modules: ['ViewBalanceHistory'],
    });
const ViewTransactions = Loadable({
    loader: () => import(/* webpackChunkName: "ViewTransactions" */ '../../jss-components/t12-transactions/ViewTransactions/index.ts'),
    loading: () => <div />,
    modules: ['ViewTransactions'],
    });
const BPAY = Loadable({
    loader: () => import(/* webpackChunkName: "BPAY" */ '../../jss-components/t13-contribution/BPAY/index.ts'),
    loading: () => <div />,
    modules: ['BPAY'],
    });
const DirectDebit = Loadable({
    loader: () => import(/* webpackChunkName: "DirectDebit" */ '../../jss-components/t13-contribution/DirectDebit/index.ts'),
    loading: () => <div />,
    modules: ['DirectDebit'],
    });
const DirectDebitForm = Loadable({
    loader: () => import(/* webpackChunkName: "DirectDebitForm" */ '../../jss-components/t13-contribution/DirectDebitForm/index.ts'),
    loading: () => <div />,
    modules: ['DirectDebitForm'],
    });
const SpouseContributionsConfirmation = Loadable({
    loader: () => import(/* webpackChunkName: "SpouseContributionsConfirmation" */ '../../jss-components/t13-contribution/SpouseContributionsConfirmation/index.ts'),
    loading: () => <div />,
    modules: ['SpouseContributionsConfirmation'],
    });
const SpouseContributionsForm = Loadable({
    loader: () => import(/* webpackChunkName: "SpouseContributionsForm" */ '../../jss-components/t13-contribution/SpouseContributionsForm/index.ts'),
    loading: () => <div />,
    modules: ['SpouseContributionsForm'],
    });
const SpouseContributionsLandingPage = Loadable({
    loader: () => import(/* webpackChunkName: "SpouseContributionsLandingPage" */ '../../jss-components/t13-contribution/SpouseContributionsLandingPage/index.ts'),
    loading: () => <div />,
    modules: ['SpouseContributionsLandingPage'],
    });
const TotalContributions = Loadable({
    loader: () => import(/* webpackChunkName: "TotalContributions" */ '../../jss-components/t13-contribution/TotalContributions/index.ts'),
    loading: () => <div />,
    modules: ['TotalContributions'],
    });
const ViewUpdateBeneficiaries = Loadable({
    loader: () => import(/* webpackChunkName: "ViewUpdateBeneficiaries" */ '../../jss-components/t14-beneficiaries/ViewUpdateBeneficiaries/index.ts'),
    loading: () => <div />,
    modules: ['ViewUpdateBeneficiaries'],
    });
const CombineSuperContext = Loadable({
    loader: () => import(/* webpackChunkName: "CombineSuperContext" */ '../../jss-components/t15-combine-super/CombineSuperContext/index.ts'),
    loading: () => <div />,
    modules: ['CombineSuperContext'],
    });
const CombineSuperForm = Loadable({
    loader: () => import(/* webpackChunkName: "CombineSuperForm" */ '../../jss-components/t15-combine-super/CombineSuperForm/index.ts'),
    loading: () => <div />,
    modules: ['CombineSuperForm'],
    });
const BenefitQuoteResults = Loadable({
    loader: () => import(/* webpackChunkName: "BenefitQuoteResults" */ '../../jss-components/t16-benefit-quote/BenefitQuoteResults/index.ts'),
    loading: () => <div />,
    modules: ['BenefitQuoteResults'],
    });
const GenerateBenefitQuote = Loadable({
    loader: () => import(/* webpackChunkName: "GenerateBenefitQuote" */ '../../jss-components/t16-benefit-quote/GenerateBenefitQuote/index.ts'),
    loading: () => <div />,
    modules: ['GenerateBenefitQuote'],
    });
const EditInvestmentOptions = Loadable({
    loader: () => import(/* webpackChunkName: "EditInvestmentOptions" */ '../../jss-components/t17-investments/EditInvestmentOptions/index.ts'),
    loading: () => <div />,
    modules: ['EditInvestmentOptions'],
    });
const ViewInvestmentPerformance = Loadable({
    loader: () => import(/* webpackChunkName: "ViewInvestmentPerformance" */ '../../jss-components/t17-investments/ViewInvestmentPerformance/index.ts'),
    loading: () => <div />,
    modules: ['ViewInvestmentPerformance'],
    });
const ViewInvestments = Loadable({
    loader: () => import(/* webpackChunkName: "ViewInvestments" */ '../../jss-components/t17-investments/ViewInvestments/index.ts'),
    loading: () => <div />,
    modules: ['ViewInvestments'],
    });
const ViewPendingInvestmentSwitch = Loadable({
    loader: () => import(/* webpackChunkName: "ViewPendingInvestmentSwitch" */ '../../jss-components/t17-investments/ViewPendingInvestmentSwitch/index.ts'),
    loading: () => <div />,
    modules: ['ViewPendingInvestmentSwitch'],
    });
const CentrelinkDownloadSection = Loadable({
    loader: () => import(/* webpackChunkName: "CentrelinkDownloadSection" */ '../../jss-components/t18-income-payments/CentrelinkDownloadSection/index.ts'),
    loading: () => <div />,
    modules: ['CentrelinkDownloadSection'],
    });
const EditPaymentAmountAndFrequency = Loadable({
    loader: () => import(/* webpackChunkName: "EditPaymentAmountAndFrequency" */ '../../jss-components/t18-income-payments/EditPaymentAmountAndFrequency/index.ts'),
    loading: () => <div />,
    modules: ['EditPaymentAmountAndFrequency'],
    });
const ViewBankDetails = Loadable({
    loader: () => import(/* webpackChunkName: "ViewBankDetails" */ '../../jss-components/t18-income-payments/ViewBankDetails/index.ts'),
    loading: () => <div />,
    modules: ['ViewBankDetails'],
    });
const ViewCentrelinkSchedule = Loadable({
    loader: () => import(/* webpackChunkName: "ViewCentrelinkSchedule" */ '../../jss-components/t18-income-payments/ViewCentrelinkSchedule/index.ts'),
    loading: () => <div />,
    modules: ['ViewCentrelinkSchedule'],
    });
const ViewPaymentDetails = Loadable({
    loader: () => import(/* webpackChunkName: "ViewPaymentDetails" */ '../../jss-components/t18-income-payments/ViewPaymentDetails/index.ts'),
    loading: () => <div />,
    modules: ['ViewPaymentDetails'],
    });
const ViewPaymentSummary = Loadable({
    loader: () => import(/* webpackChunkName: "ViewPaymentSummary" */ '../../jss-components/t18-income-payments/ViewPaymentSummary/index.ts'),
    loading: () => <div />,
    modules: ['ViewPaymentSummary'],
    });
const FinancialHardshipA = Loadable({
    loader: () => import(/* webpackChunkName: "FinancialHardshipA" */ '../../jss-components/t19-withdrawals/FinancialHardship/FinancialHardshipA/index.ts'),
    loading: () => <div />,
    modules: ['FinancialHardshipA'],
    });
const FinancialHardshipB = Loadable({
    loader: () => import(/* webpackChunkName: "FinancialHardshipB" */ '../../jss-components/t19-withdrawals/FinancialHardship/FinancialHardshipB/index.ts'),
    loading: () => <div />,
    modules: ['FinancialHardshipB'],
    });
const Pension = Loadable({
    loader: () => import(/* webpackChunkName: "Pension" */ '../../jss-components/t19-withdrawals/Pension/index.ts'),
    loading: () => <div />,
    modules: ['Pension'],
    });
const ReachedPreservationAge = Loadable({
    loader: () => import(/* webpackChunkName: "ReachedPreservationAge" */ '../../jss-components/t19-withdrawals/ReachedPreservationAge/index.ts'),
    loading: () => <div />,
    modules: ['ReachedPreservationAge'],
    });
const TransferToAnotherFund = Loadable({
    loader: () => import(/* webpackChunkName: "TransferToAnotherFund" */ '../../jss-components/t19-withdrawals/TransferToAnotherFund/index.ts'),
    loading: () => <div />,
    modules: ['TransferToAnotherFund'],
    });
const UnrestrictedNonPreserved = Loadable({
    loader: () => import(/* webpackChunkName: "UnrestrictedNonPreserved" */ '../../jss-components/t19-withdrawals/UnrestrictedNonPreserved/index.ts'),
    loading: () => <div />,
    modules: ['UnrestrictedNonPreserved'],
    });
const WithdrawalsLandingPage = Loadable({
    loader: () => import(/* webpackChunkName: "WithdrawalsLandingPage" */ '../../jss-components/t19-withdrawals/WithdrawalsLandingPage/index.ts'),
    loading: () => <div />,
    modules: ['WithdrawalsLandingPage'],
    });
const LoadingScreen = Loadable({
    loader: () => import(/* webpackChunkName: "LoadingScreen" */ '../../jss-components/t19-withdrawals/subcomponents/LoadingScreen/index.ts'),
    loading: () => <div />,
    modules: ['LoadingScreen'],
    });
const MobileRestrictionScreen = Loadable({
    loader: () => import(/* webpackChunkName: "MobileRestrictionScreen" */ '../../jss-components/t19-withdrawals/subcomponents/MobileRestrictionScreen/index.ts'),
    loading: () => <div />,
    modules: ['MobileRestrictionScreen'],
    });
const RenderButtons = Loadable({
    loader: () => import(/* webpackChunkName: "RenderButtons" */ '../../jss-components/t19-withdrawals/subcomponents/RenderButtons/index.ts'),
    loading: () => <div />,
    modules: ['RenderButtons'],
    });
const SaveScreen = Loadable({
    loader: () => import(/* webpackChunkName: "SaveScreen" */ '../../jss-components/t19-withdrawals/subcomponents/SaveScreen/index.ts'),
    loading: () => <div />,
    modules: ['SaveScreen'],
    });
const WithdrawalsErrorModal = Loadable({
    loader: () => import(/* webpackChunkName: "WithdrawalsErrorModal" */ '../../jss-components/t19-withdrawals/subcomponents/WithdrawalsErrorModal/index.ts'),
    loading: () => <div />,
    modules: ['WithdrawalsErrorModal'],
    });
const ViewInsuranceCover = Loadable({
    loader: () => import(/* webpackChunkName: "ViewInsuranceCover" */ '../../jss-components/t20-insurance/ViewInsuranceCover/index.ts'),
    loading: () => <div />,
    modules: ['ViewInsuranceCover'],
    });
const ViewInsuranceCoverSummary = Loadable({
    loader: () => import(/* webpackChunkName: "ViewInsuranceCoverSummary" */ '../../jss-components/t20-insurance/ViewInsuranceCoverSummary/index.ts'),
    loading: () => <div />,
    modules: ['ViewInsuranceCoverSummary'],
    });
const CommunicationPreferences = Loadable({
    loader: () => import(/* webpackChunkName: "CommunicationPreferences" */ '../../jss-components/t21-communication/CommunicationPreferences/index.ts'),
    loading: () => <div />,
    modules: ['CommunicationPreferences'],
    });
const InboxMessagesAndNotifications = Loadable({
    loader: () => import(/* webpackChunkName: "InboxMessagesAndNotifications" */ '../../jss-components/t21-communication/InboxMessagesAndNotifications/index.ts'),
    loading: () => <div />,
    modules: ['InboxMessagesAndNotifications'],
    });
const TaxFileNumber = Loadable({
    loader: () => import(/* webpackChunkName: "TaxFileNumber" */ '../../jss-components/t24-tax-file-number/TaxFileNumber/index.ts'),
    loading: () => <div />,
    modules: ['TaxFileNumber'],
    });
const LivePerson = Loadable({
    loader: () => import(/* webpackChunkName: "LivePerson" */ '../../jss-components/t25-live-person/LivePerson/index.ts'),
    loading: () => <div />,
    modules: ['LivePerson'],
    });
const NoticeOfIntentForm = Loadable({
    loader: () => import(/* webpackChunkName: "NoticeOfIntentForm" */ '../../jss-components/t26-claim-tax-deduction/NoticeOfIntentForm/index.ts'),
    loading: () => <div />,
    modules: ['NoticeOfIntentForm'],
    });
const NoticeOfIntentLandingPage = Loadable({
    loader: () => import(/* webpackChunkName: "NoticeOfIntentLandingPage" */ '../../jss-components/t26-claim-tax-deduction/NoticeOfIntentLandingPage/index.ts'),
    loading: () => <div />,
    modules: ['NoticeOfIntentLandingPage'],
    });
const ChangeBankDetailsForm = Loadable({
    loader: () => import(/* webpackChunkName: "ChangeBankDetailsForm" */ '../../jss-components/t27-change-bank-details/ChangeBankDetailsForm/index.ts'),
    loading: () => <div />,
    modules: ['ChangeBankDetailsForm'],
    });
const ChangeBankDetailsLandingPage = Loadable({
    loader: () => import(/* webpackChunkName: "ChangeBankDetailsLandingPage" */ '../../jss-components/t27-change-bank-details/ChangeBankDetailsLandingPage/index.ts'),
    loading: () => <div />,
    modules: ['ChangeBankDetailsLandingPage'],
    });

const components = new Map();
components.set('UnauthoredComponent', UnauthoredComponent);
components.set('Breadcrumbs', Breadcrumbs);
components.set('Footer', Footer);
components.set('Header', Header);
components.set('Dashboard', Dashboard);
components.set('GeneralOneColumn', GeneralOneColumn);
components.set('GeneralTwoColumnLeft', GeneralTwoColumnLeft);
components.set('GeneralTwoColumnRight', GeneralTwoColumnRight);
components.set('UnauthenticatedOneColumn', UnauthenticatedOneColumn);
components.set('Accordion', Accordion);
components.set('ContentBlock', ContentBlock);
components.set('DownloadsBlock', DownloadsBlock);
components.set('HeroModule', HeroModule);
components.set('IconTile', IconTile);
components.set('ImageBlock', ImageBlock);
components.set('LinksBlock', LinksBlock);
components.set('MemberDetailsForm', MemberDetailsForm);
components.set('MemberPreferencesLink', MemberPreferencesLink);
components.set('PageLevelNotification', PageLevelNotification);
components.set('QuickActionsList', QuickActionsList);
components.set('QuickActionsTile', QuickActionsTile);
components.set('RichText', RichText);
components.set('Tabs', Tabs);
components.set('VideoBlock', VideoBlock);
components.set('FiftyFiftySubLayout', FiftyFiftySubLayout);
components.set('FullWidthSubLayout', FullWidthSubLayout);
components.set('OneThirdTwoThirdsSubLayout', OneThirdTwoThirdsSubLayout);
components.set('QuartersSubLayout', QuartersSubLayout);
components.set('ThirdsSubLayout', ThirdsSubLayout);
components.set('TwoThirdsOneThirdSubLayout', TwoThirdsOneThirdSubLayout);
components.set('GreenId', GreenId);
components.set('OneTimePasscode', OneTimePasscode);
components.set('DbAccountSnapshot', DbAccountSnapshot);
components.set('DbAnnualStatements', DbAnnualStatements);
components.set('DbBPAY', DbBPAY);
components.set('DbBeneficiaries', DbBeneficiaries);
components.set('DbFinancialAdviserModule', DbFinancialAdviserModule);
components.set('DbHeroBanner', DbHeroBanner);
components.set('DbImportantNotice', DbImportantNotice);
components.set('DbInsuranceCover', DbInsuranceCover);
components.set('DbInvestments', DbInvestments);
components.set('DbLatestContributionModule', DbLatestContributionModule);
components.set('DbNextBestActionsModule', DbNextBestActionsModule);
components.set('DbNoiInformationBanner', DbNoiInformationBanner);
components.set('DbPaymentInformation', DbPaymentInformation);
components.set('DbProfileSetupActions', DbProfileSetupActions);
components.set('DbSectionHeading', DbSectionHeading);
components.set('DbSkeletonLoader', DbSkeletonLoader);
components.set('DbVideoBlock', DbVideoBlock);
components.set('Widget', Widget);
components.set('AccountLockedScreen', AccountLockedScreen);
components.set('ContentNotAvailable', ContentNotAvailable);
components.set('DeviceCheck', DeviceCheck);
components.set('DisplayLogoutSuccess', DisplayLogoutSuccess);
components.set('EditUsernameAndPassword', EditUsernameAndPassword);
components.set('Login', Login);
components.set('MPRegistrationForm', MPRegistrationForm);
components.set('OnboardingJourney', OnboardingJourney);
components.set('RecoverUsername', RecoverUsername);
components.set('ResetPassword', ResetPassword);
components.set('ResilienceMaintenance', ResilienceMaintenance);
components.set('WelcomeBanner', WelcomeBanner);
components.set('WelcomeDashboardModule', WelcomeDashboardModule);
components.set('PendingProfileAccountDetailsModule', PendingProfileAccountDetailsModule);
components.set('PendingProfileActionsModule', PendingProfileActionsModule);
components.set('AccountSwitcher', AccountSwitcher);
components.set('MemberContactDetails', MemberContactDetails);
components.set('RestrictionNotification', RestrictionNotification);
components.set('AnnualStatements', AnnualStatements);
components.set('SavedApplications', SavedApplications);
components.set('SubmittedApplications', SubmittedApplications);
components.set('SubmittedBankAccount', SubmittedBankAccount);
components.set('SubmittedDirectDebit', SubmittedDirectDebit);
components.set('SubmittedFinancialHardship', SubmittedFinancialHardship);
components.set('SubmittedNoticeOfIntent', SubmittedNoticeOfIntent);
components.set('SubmittedReachedPreservationAge', SubmittedReachedPreservationAge);
components.set('SubmittedSpouseContribution', SubmittedSpouseContribution);
components.set('SubmittedTransferToAnotherFund', SubmittedTransferToAnotherFund);
components.set('SubmittedUnrestrictedNonPreserved', SubmittedUnrestrictedNonPreserved);
components.set('ViewApplicationDetails', ViewApplicationDetails);
components.set('AccountsDetailsModule', AccountsDetailsModule);
components.set('NotifyYourEmployer', NotifyYourEmployer);
components.set('NotifyYourEmployerConfirmation', NotifyYourEmployerConfirmation);
components.set('TransactionsSummary', TransactionsSummary);
components.set('ViewBalanceHistory', ViewBalanceHistory);
components.set('ViewTransactions', ViewTransactions);
components.set('BPAY', BPAY);
components.set('DirectDebit', DirectDebit);
components.set('DirectDebitForm', DirectDebitForm);
components.set('SpouseContributionsConfirmation', SpouseContributionsConfirmation);
components.set('SpouseContributionsForm', SpouseContributionsForm);
components.set('SpouseContributionsLandingPage', SpouseContributionsLandingPage);
components.set('TotalContributions', TotalContributions);
components.set('ViewUpdateBeneficiaries', ViewUpdateBeneficiaries);
components.set('CombineSuperContext', CombineSuperContext);
components.set('CombineSuperForm', CombineSuperForm);
components.set('BenefitQuoteResults', BenefitQuoteResults);
components.set('GenerateBenefitQuote', GenerateBenefitQuote);
components.set('EditInvestmentOptions', EditInvestmentOptions);
components.set('ViewInvestmentPerformance', ViewInvestmentPerformance);
components.set('ViewInvestments', ViewInvestments);
components.set('ViewPendingInvestmentSwitch', ViewPendingInvestmentSwitch);
components.set('CentrelinkDownloadSection', CentrelinkDownloadSection);
components.set('EditPaymentAmountAndFrequency', EditPaymentAmountAndFrequency);
components.set('ViewBankDetails', ViewBankDetails);
components.set('ViewCentrelinkSchedule', ViewCentrelinkSchedule);
components.set('ViewPaymentDetails', ViewPaymentDetails);
components.set('ViewPaymentSummary', ViewPaymentSummary);
components.set('FinancialHardshipA', FinancialHardshipA);
components.set('FinancialHardshipB', FinancialHardshipB);
components.set('Pension', Pension);
components.set('ReachedPreservationAge', ReachedPreservationAge);
components.set('TransferToAnotherFund', TransferToAnotherFund);
components.set('UnrestrictedNonPreserved', UnrestrictedNonPreserved);
components.set('WithdrawalsLandingPage', WithdrawalsLandingPage);
components.set('LoadingScreen', LoadingScreen);
components.set('MobileRestrictionScreen', MobileRestrictionScreen);
components.set('RenderButtons', RenderButtons);
components.set('SaveScreen', SaveScreen);
components.set('WithdrawalsErrorModal', WithdrawalsErrorModal);
components.set('ViewInsuranceCover', ViewInsuranceCover);
components.set('ViewInsuranceCoverSummary', ViewInsuranceCoverSummary);
components.set('CommunicationPreferences', CommunicationPreferences);
components.set('InboxMessagesAndNotifications', InboxMessagesAndNotifications);
components.set('TaxFileNumber', TaxFileNumber);
components.set('LivePerson', LivePerson);
components.set('NoticeOfIntentForm', NoticeOfIntentForm);
components.set('NoticeOfIntentLandingPage', NoticeOfIntentLandingPage);
components.set('ChangeBankDetailsForm', ChangeBankDetailsForm);
components.set('ChangeBankDetailsLandingPage', ChangeBankDetailsLandingPage);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
